import { useMediaQuery } from 'react-responsive'; 
import DesktopHome from './components/Desktop/Desktop'; // Adjust path if needed
import MobileHome from './components/Mobile/Mobile';  
import './App.css';
function App() {
  const isDesktop = useMediaQuery({ query: '(min-width: 768px)' });

  return (
    <div> 
      {isDesktop ? <DesktopHome /> : <MobileHome />}
    </div>
  );
}

export default App;
